<template>
  <KTPortlet title="Заказы">
    <div slot="body">
      <SelectVehicleDialog ref="dialog" @select="onSelectVehicle" />
      <v-data-table :headers="fields" :items="orders" :items-per-page="15">
        <template v-slot:item.order.date="data">{{
          formatDateTime(data.item.order.date)
        }}</template>
        <template v-slot:item.units="data"
          >{{ data.item.units }}
          {{ data.item.measure_unit.name.toLowerCase() }}</template
        >
        <template v-slot:item.price_by_unit="data"
          >{{ data.item.price_by_unit }} за
          {{ data.item.measure_unit.name.toLowerCase() }}</template
        >
        <template v-slot:item.client_payment="data">
          <span
            class="badge badge-success badge-inline"
            v-if="data.item.order.payment_type == 'non_cash'"
            >Безналичный</span
          >
          <span class="badge badge-info badge-inline" v-else>Наличными</span>
        </template>
        <template v-slot:item.commission="data">
          {{ data.item.commission }}
          <template v-if="data.item.commission_type == 'percent'">%</template>
        </template>
        <template v-slot:item.order.dispatcher.name="data"
          >{{ data.item.order.dispatcher.name }}
          <a :href="`tel:${data.item.order.dispatcher.phone}`">{{
            data.item.order.dispatcher.phone
          }}</a></template
        >
        <template v-slot:item.action="data">
          <v-btn
            color="error"
            @click="
              () => {
                rejectOrder(data.item);
              }
            "
            v-if="data.item.assigned"
            >Отказаться</v-btn
          >
          <v-btn
            color="primary"
            @click="
              () => {
                initAcceptOrder(data.item);
              }
            "
            v-else
            >Принять</v-btn
          >
        </template>
      </v-data-table>
    </div>
  </KTPortlet>
</template>

<script>
import KTPortlet from "@/view/content/Card.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import SelectVehicleDialog from "@/view/pages/orders/SelectVehicleDialog.vue";

import moment from "moment";
moment.locale("ru");

export default {
  name: "orders",
  metaInfo: {
    title: "Заказы",
  },
  components: { KTPortlet, SelectVehicleDialog },
  data() {
    return {
      loading: false,
      orders: [],
      vehicles: [],
      modalShow: false,
      currentOrder: null,
      fields: [
        {
          value: "vehicle_type.name",
          text: "Тип",
        },
        {
          value: "order.canonical_id",
          text: "№ заказа",
        },
        {
          value: "order.date",
          text: "Дата",
        },
        {
          value: "order.address",
          text: "Адрес",
        },
        {
          value: "units",
          text: "Примерно",
        },
        {
          value: "price_by_unit",
          text: "Стоимость",
        },
        {
          value: "client_payment",
          text: "Оплата",
        },
        {
          value: "commission",
          text: "Комиссия",
        },
        {
          value: "order.description",
          text: "Доп. инфо",
        },
        {
          value: "order.dispatcher.name",
          text: "Диспетчер",
        },
        {
          value: "action",
          text: "",
        },
      ],
    };
  },
  computed: {
    availableVehicles() {
      if (this.currentOrder) {
        return this.vehicles.filter(
          (vehicle) =>
            vehicle.vehicle_type.id == this.currentOrder.vehicle_type.id
        );
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Заказы" }]);
    this.fetchDataVehicles();
    this.fetchData();
  },
  methods: {
    fetchDataVehicles() {
      this.$api["contractor/vehicles"]
        .select()
        .then((response) => {
          this.vehicles = response.data.items;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchData() {
      this.loading = true;
      this.$api["contractor/orders"]
        .selectAvailable()
        .then((response) => {
          this.orders = response.data.items;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDateTime(time) {
      return moment(time).format("dddd DD MMMM YYYY к h:mm");
    },
    onSelectVehicle(vehicle_id) {
      this.acceptOrder(this.currentOrder.id, vehicle_id);
    },
    initAcceptOrder(item) {
      this.currentOrder = item;

      if (this.availableVehicles.length > 1) {
        this.$refs.dialog.open(this.availableVehicles);
      } else {
        this.acceptOrder(this.currentOrder.id, this.availableVehicles[0].id);
      }
    },
    acceptOrder(subOrderId, vehicleId) {
      this.$api["contractor/orders"]
        .accept(subOrderId, vehicleId)
        .then(() => {
          this.$toast.success("Операция выполнена.");
          this.fetchData();
        })
        .catch((error) => {
          this.$toast.error(error.response.data.errors.base.join(", "), {
            icon: "fa-exclamation-circle",
          });
        });
    },
    rejectOrder(item) {
      this.$api["contractor/orders"]
        .reject(item.id)
        .then(() => {
          this.$toast.success("Операция выполнена.");
          this.fetchData();
        })
        .catch((error) => {
          this.$toast.error(error.response.data.errors.base.join(", "), {
            icon: "fa-exclamation-circle",
          });
        });
    },
  },
};
</script>
